import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPaginationState {
  data: any;
  filters: Record<string, string | number>;
  searchQuery: string;
}

const initialState: IPaginationState = {
  data: [],
  filters: {
    period: "last_30_days",
  },
  searchQuery: "",
};

const PaginationSlice = createSlice({
  name: "RiskExposureAssessmentPagination",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;
      state.data = data;
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
  },
});

export const { setData, setFilters, setSearchQuery } = PaginationSlice.actions;

export const selectPagination = (state: any) =>
  state.RiskExposureAssessmentPagination;

export default PaginationSlice.reducer;
